import {Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {ModalController} from '@ionic/angular/standalone';
import { IonHeader, IonToolbar, IonButton, IonTitle, IonContent } from '@ionic/angular/standalone';
import * as htmltoimage from 'html-to-image';
import {Directory, Filesystem} from '@capacitor/filesystem';
import {Capacitor} from "@capacitor/core";
import {DisplayService} from "@qid/core";
import {Environment, ENVIRONMENT} from "@qid/env";
import {Scanner} from '../../models/scanner';
import {CollectionTemplate} from "../../../collection-template";
import { CommonModule } from '@angular/common';
import { SuperButtonComponent, SuperInputComponent } from '@qid/super';
import { SexyModule } from '@qid/sexy';

@Component({
    selector: 'app-share-qr-template',
    templateUrl: './share-qr-template.component.html',
    styleUrls: ['./share-qr-template.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        SexyModule,
        SuperButtonComponent,
        IonHeader,
        IonToolbar,
        IonButton,
        IonTitle,
        IonContent
    ]
})
export class ShareQrTemplateComponent implements OnInit {

    @Input() scanner: Scanner;
    @Input() template: CollectionTemplate;
    @Input() loading: boolean = false;

    @ViewChild('qrwrapper') qrwrapper: any;

    baseUrl: string = this.environment.collectUrl;

    constructor(
        private modelController: ModalController,
        private displayService: DisplayService,
        @Inject(ENVIRONMENT) private environment: Environment
    ) {
    }

    ngOnInit() {
    }


    close() {
        this.modelController.dismiss();
    }

    async share(template: CollectionTemplate) {

        const dataUrl = await this.getQRImage()

        const text =
            'Quickly share your IDs with ' +
            template.org?.name +
            ' for ' +
            template.purpose;


    }

    shareToLocal = async () => {

        if (!Capacitor.isNativePlatform()) {
            return this.saveOnDesktop()
        }

        if (Capacitor.getPlatform() == 'ios') {
            return this.displayService.toast({message: "QR Saved"})
        }

        await this.saveOnPhone(await this.getQRImage(), this.template.purpose + "_qid_qr.jpeg");
        await this.displayService.toast({message: 'QR Saved Successfully. You can find it in your device storage'});

    };

    async saveOnDesktop() {
        let link = document.createElement("a");
        document.body.appendChild(link);
        link.setAttribute("href", await this.getQRImage());
        link.setAttribute("download", this.template.purpose + "_qid_qr.jpeg");
        link.click();
        link.remove();
    }

    async saveOnPhone(data, filename) {
        const permissionStatus = await Filesystem.checkPermissions();
        if (permissionStatus.publicStorage != 'granted') {
            await Filesystem.requestPermissions();
        }
        const res = await Filesystem.writeFile({
            path: filename,
            data: data,
            directory: Directory.Documents,
        });
    }


    private getQRImage() {
        const node = this.qrwrapper.nativeElement;
        return htmltoimage.toJpeg(node);
    }

}
